import { z } from "zod";

const forgotSenhaSchema = z.object({
  email: z
    .string({ message: "O email não pode ser vazio!" })
    .email()
    .max(55, "O email é muito grande, tente novamente!"),
});

export type iForgotSenhaData = z.infer<typeof forgotSenhaSchema>;

export { forgotSenhaSchema };
